<div class="profile-container" (click)="toggleMenu()" data-testid="profile-menu">
  <svg-icon class="profile-icon mr-2" key="profile" fontSize="25px"></svg-icon>
  <span>{{ userName$ | async }}</span>
  <svg-icon class="menu-icon ml-3" key="caret-down" fontSize="11px"></svg-icon>
</div>

<div class="dropdown-menu" [class.d-none]="!menuVisible">
  <div class="dropdown-menu-header">
    <osn-cxb-tenant-logo [section]="TenantLogoSection.Profile"></osn-cxb-tenant-logo>
    <div class="user-info" data-testid="profile-menu-user-info">
      <span class="user-name">{{ userName$ | async }}</span>
      <span class="user-email">{{ userEmail$ | async }}</span>
    </div>
  </div>
  <div class="menu-options">
    <ng-container *ngIf="dataForTenantSwitch$ | async as dataForTenantSwitch">
      <div
        *ngIf="dataForTenantSwitch[2]"
        class="menu-option-container"
        (click)="onSwitchTenantClicked(dataForTenantSwitch)"
        data-testid="profile-menu-switch-tenant-menu-option"
      >
        <svg-icon class="menu-icon mr-2" key="back-and-forth-arrows" fontSize="13px"></svg-icon>
        <span>Switch platform provider</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!router.url.startsWith('/root') && isGeneralSettingsAvailable$ | async">
      <div class="menu-option-container" (click)="onGeneralSettingsClicked()" data-testid="profile-menu-general-settings-menu-option">
        <svg-icon class="menu-icon mr-1" key="settings" fontSize="18px"></svg-icon>
        <span>General settings</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!router.url.startsWith('/root') && isNavigateToOnDemandContentGroupLinkAvailable$ | async">
      <div
        class="menu-option-container"
        (click)="onClickOnDemandContentGroups()"
        data-testid="profile-menu-onDemand-content-groups-menu option"
      >
        <svg-icon class="menu-icon mr-2" key="signal" fontSize="12px"></svg-icon>
        <span>Content groups</span>
      </div>
    </ng-container>
    <ng-container *ngIf="router.url.startsWith('/root') && selectedTenant$ | async as selectedTenant">
      <div class="menu-option-container" (click)="onGeneralSettingsClicked()" data-testid="profile-menu-back-to-tenant-menu-option">
        <svg-icon class="menu-icon mr-1" key="rewind" fontSize="16px"></svg-icon>
        <span>Go back to {{ selectedTenant.name }}</span>
      </div>
    </ng-container>
    <div class="menu-option-container" (click)="onLogoutClicked()" data-testid="profile-menu-logout-menu-option">
      <svg-icon class="menu-icon mr-2" key="sign-out" fontSize="13px"></svg-icon>
      <span>Sign Out</span>
    </div>
  </div>
</div>
